import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.authService.isAuthenticated()) {
      return true;
    }
    // Redirect to sign-in, preserving the attempted URL so the user returns there after login.
    // Important for the DocuSign return URL (e.g. /routing-slip-details?id=...&event=signing_complete),
    // which can load in a tab that is not yet signed in.
    return this.router.createUrlTree(['/sign-in'], {
      queryParams: { returnUrl: state.url },
    });
  }
}
